import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Maria Rodriguez",
      business: "Rosa's Bakery, Miami",
      content: "Processing Bros saved our bakery $2,400 every month. Now customers pay the processing fees through their cash discount program, and we keep 100% of our revenue. The team explained everything clearly and helped us stay compliant.",
      rating: 5,
      savings: "$2,400/month"
    },
    {
      name: "James Chen", 
      business: "Downtown Auto Repair",
      content: "I was skeptical at first, but their rate analysis showed I was paying almost 4% in fees. They got me down to 2.8% and eliminated all the hidden fees. Professional service and transparent pricing - exactly what they promised.",
      rating: 5,
      savings: "$1,800/month"
    },
    {
      name: "Sarah Williams",
      business: "Coastal Boutique",
      content: "The cash discount program has been a game-changer for our retail store. Customers don't mind the small discount fee, and we're saving over $1,500 monthly. Processing Bros handled all the setup and compliance paperwork.",
      rating: 5,
      savings: "$1,500/month"
    }
  ];

  return (
    <section className="py-20 bg-muted/30" aria-labelledby="testimonials-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 id="testimonials-heading" className="text-3xl md:text-4xl font-bold mb-4">
            Real Results from Real Businesses
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Don't take our word for it. Here's what our merchant partners say about working with Processing Bros.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-2 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <CardContent className="p-8">
                {/* Rating Stars */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                {/* Testimonial Content */}
                <blockquote className="text-muted-foreground mb-6 leading-relaxed">
                  "{testimonial.content}"
                </blockquote>
                
                {/* Savings Highlight */}
                <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-6">
                  <p className="text-green-700 font-semibold text-center">
                    Monthly Savings: {testimonial.savings}
                  </p>
                </div>
                
                {/* Author Info */}
                <div className="flex items-center">
                  <Avatar className="h-12 w-12 mr-4">
                    <AvatarFallback className="bg-primary text-primary-foreground font-semibold">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-semibold">{testimonial.name}</p>
                    <p className="text-sm text-muted-foreground">{testimonial.business}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-muted-foreground">
            Ready to join them? <span className="font-semibold">Call (954) 399-2230</span> or get your free analysis below.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;